import { useTranslation } from 'react-i18next'
import mark from '../../../assets/images/mark.webp'
import './reasons.scss'

const Reasons: React.FC = () => {
    const { t } = useTranslation()

    return (
        <section className="reasons">
            <div className="container">
                <div className="reasons__text">
                    <h2 className="reasons__text-header">{t('reasons.title')}</h2>
                    <p className="reasons__text-p">{t('reasons.paragraph1')}</p>
                    <p className="reasons__text-p">{t('reasons.paragraph2')}</p>
                </div>
                <img src={mark} alt="mark" className="reasons__img" />
            </div>
        </section>
    )
}

export default Reasons
